import { DocumentoAllegato } from './documento-allegato';
import { Esito } from './esito';
import { TipoEsecuzione } from './tipologiche/tipo-esecuzione';

export class SchedaEsecuzione {
    esito: Esito;
    id: string;
   // controparti: Controparte[];
    //posizione: string;
    documenti: DocumentoAllegato[];
    // tipoSomma: TipoSomma;
    // modalitaErogazione: ModalitaErogazione;
   // importo: number;
    corrispondente: string;
    pagamentoSorteQuantificatoRuoloPaga	:string;
    pagamentoSorteQuantificatoBsf	:string;
    pagamentoSorteNonQuantificatoRuoloPaga	:string;
    pagamentoSorteNonQuantificatoBsf	:string;
    //pagamentiSorte: PagamentoSorte[];
    adempimenti: string;
    tipoSchedaEsecuzione: TipoEsecuzione;
    sommaQuantificata?: boolean;
    sommaNonQuantificata?: boolean;
    note: string;
    dataCreazione: string;
    constructor(obj?: SchedaEsecuzione){
        if(obj){
            this.id=obj.id;
            this.esito=obj.esito;
          //  this.controparti=obj.controparti;
           // this.posizione=obj.posizione;
            this.documenti=obj.documenti;
            // this.tipoSomma=obj.tipoSomma;
            // this.modalitaErogazione=obj.modalitaErogazione;
           // this.importo=obj.importo;
            this.corrispondente=obj.corrispondente;
            this.pagamentoSorteQuantificatoBsf=obj.pagamentoSorteQuantificatoBsf;
            this.pagamentoSorteNonQuantificatoBsf=obj.pagamentoSorteNonQuantificatoBsf;
            this.pagamentoSorteQuantificatoRuoloPaga=obj.pagamentoSorteQuantificatoRuoloPaga;
            this.pagamentoSorteNonQuantificatoRuoloPaga=obj.pagamentoSorteNonQuantificatoRuoloPaga;
           // this.pagamentiSorte=obj.pagamentiSorte;
            this.adempimenti=obj.adempimenti;
            this.sommaQuantificata=obj.sommaQuantificata;
            this.sommaNonQuantificata=obj.sommaNonQuantificata;
            this.tipoSchedaEsecuzione=obj.tipoSchedaEsecuzione;
            this.note=obj.note;
            this.dataCreazione=obj.dataCreazione;
        }
    }

}
